<!-- This componnet adds a wrapper component to the wrapped content. If no wrapper component is provided, we simply renders the child content. -->
<!-- This is useful if we want to conditionally add a parent component  -->
<script>
  export let wrapper = null;
</script>

{#if wrapper}
  <svelte:component this={wrapper} {...$$restProps}>
    <slot />
  </svelte:component>
{:else}
  <slot />
{/if}
